<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="top-box">
      <div class="content-positioning">
        <div class="title-1">行业分析</div>
        <div class="title-2">AI 数据洞察，助力企业科学决策</div>
        <div class="btn-group">
          <div class="btn-primary" @click="openContactUs">申请试用</div>
          <div class="btn-secondary">查看案例</div>
        </div>
      </div>
    </div>

    <!-- 核心功能 -->
    <div class="capability-section">
      <div class="section-title">核心功能</div>
      <div class="capability-grid">
        <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
          <div class="capability-icon">{{ item.icon }}</div>
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="scenario-section">
      <div class="section-title">应用场景</div>
      <div class="scenario-grid">
        <div class="scenario-card" v-for="(item, index) in scenarioList" :key="index">
          <div class="scenario-icon">{{ item.icon }}</div>
          <div class="scenario-title">{{ item.name }}</div>
          <div class="scenario-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 底部联系方式 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.aiAnalysis,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: '📊', name: '数据采集', desc: '多源数据自动采集整合' },
        { icon: '🔍', name: '智能分析', desc: 'AI 驱动的深度数据分析' },
        { icon: '📈', name: '趋势预测', desc: '行业趋势智能预测' },
        { icon: '📋', name: '报告生成', desc: '自动生成分析报告' }
      ],
      scenarioList: [
        { icon: '🏬', name: '零售分析', desc: '消费行为、竞品分析' },
        { icon: '🏭', name: '制造分析', desc: '产能、质量、供应链' },
        { icon: '🏥', name: '医疗分析', desc: '疾病趋势、医疗资源' },
        { icon: '🏦', name: '金融分析', desc: '风险控制、市场预测' }
      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', '行业分析')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-positioning {
  max-width: 800px;
  text-align: center;
  color: #fff;

  .title-1 {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .title-2 {
    font-size: 20px;
    opacity: 0.9;
    margin-bottom: 40px;
  }

  .btn-group {
    display: flex;
    gap: 20px;
    justify-content: center;

    .btn-primary, .btn-secondary {
      padding: 14px 40px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
      }
    }

    .btn-primary {
      background: #fff;
      color: #667eea;
      font-weight: bold;
    }

    .btn-secondary {
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
    }
  }
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
  color: #222;
}

.capability-section, .scenario-section {
  padding: 80px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.capability-grid, .scenario-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.capability-card, .scenario-card {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-8px);
  }
}

.capability-icon, .scenario-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.capability-name, .scenario-title {
  font-size: 20px;
  font-weight: bold;
  color: #222;
  margin-bottom: 12px;
}

.capability-desc, .scenario-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
</style>
